/**
 * props: {
*     e5namespace: e5命名空间---必须
  *  dialogCom: dialog组件对象---默认{}
*     openNamespace: openWindow用到的命名空间,对应options.js文件里的定义---默认空''
  *  contextMenuFlag: 是否需要右键菜单---默认不需要false
 *  tableActionFlag: 是否显示列表的操作按钮（刷新，设置，下载等），默认显示
 *  primaryFlag：操作展示样式，false为默认样式，true为primary
 *  isAutoExpandRootNode[Boolean]:是否默认展开文件夹树的根节点，默认false不展开
 *  isNeedPostAction[Boolean]:是否需要操作后处理，默认true，需要
  * }
 */

import { options } from '@common'
export default {
  props: {
    primaryFlag: {
      type: Boolean,
      default: false
    },
    e5namespace: {
      type: String,
      required: true
    },
    dialogCom: {
      type: Object,
      default () {
        return {}
      }
    },
    openNamespace: {
      type: String,
      default: undefined
    },
    hideLineActions: {
      type: Boolean,
      default: false
    },
    contextMenuFlag: {
      type: Boolean,
      default: false
    },
    metadataProps: {
      type: Object,
      default () {
        return {}
      }
    },
    tableActionFlag: {
      type: Boolean,
      default: true
    },
    isNeedPostAction: {
      type: Boolean,
      default: true
    },
    actionFixedWidth: {
      type: String,
      default: 'auto'
    },
    isAutoExpandRootNode: {
      type: Boolean,
      default: false
    },
    subComConfig: {
      type: Object,
      default () {
        return {
          e5namespace: 'e5'
        }
      }
    },
    openNoneSuccess: {
      type: Function,
      default (data) {
        console.log(data)
      }
    },
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    /**
     * 用来设置列表中点击某一项打开的dialog的一些属性，目前只支持设置dialog的宽高
     * 数据结构：
     * [{
     *     modDetail: '', // 打开模块名，要和后台配置返回的保持一致
     *     width: '1000px',
     *     height: '500px'
     * }]
     */
    detailDialogConfigs: {
      type: Array,
      default: () => { return [] }
    },
    condition: {
      type: Array,
      default: () => { return [] }
    }
  },
  computed: {
    metadata () {
      return this.$store.state[this.e5namespace].metadata
    },
    ids () {
      return this.$store.state[this.e5namespace].ids
    },
    tableType () {
      return this.$store.state[this.e5namespace].tableType
    },
    currentPreaction: function () {
      return this.$store.state[this.e5namespace].currentPreaction
    },
    paginationData: function () {
      return this.$store.state[this.e5namespace].paginationData
    },
    formData: function () {
      return this.$store.state[this.e5namespace].formData
    },
    tableSortColumn: function () {
      return this.$store.state[this.e5namespace].tableSortColumn
    }
  },
  methods: {
    customUpdateForm () {
      return this.$store.dispatch(this.e5namespace + '/customUpdateForm', ...arguments)
    },
    getSiteId () {
      return this.$store.dispatch('login/getSiteId')
    },
    // 更新metadata
    FETCH_META_DATA: function () {
      return this.$store.dispatch(this.e5namespace + '/FETCH_META_DATA', ...arguments)
    },
    openDialog (action) {
      if (action.url.indexOf('BASE:') > -1) {
        action.url = action.url.replace('BASE:', '')
      }
      this.$refs.action.dialogVisible = false
      if (this.contextMenuFlag) {
        this.$refs.table.$refs.tableMenu.dialogVisible = false
      }
      this.$refs.dialog.openDialog(action)
    },
    openDetailDialog (data) {
      this.$refs.table.openDetailDialog(data)
    },
    openConfirm (action) {
      this.$refs.dialog.openConfirm(action)
    },
    openWindow (action) {
      let base = this.currentPreaction.headers['base-param']
      if (this.site) {
        let tmp = JSON.parse(base)
        tmp.site = this.site
        base = JSON.stringify(tmp)
      }
      window.open(options.options.getOpenUrl({
        url: this.openNamespace ? options.options.urls[this.openNamespace][action.url] : options.options[action.url],
        params: {
          base: base,
          ...action.$params
        }
      }))
    },
    openNone (action) {
      this.$emit('openNone', action)
    },
    propsGetOpenUrl (data) {
      return options.options.getOpenUrl({
        url: this.openNamespace ? options.options.urls[this.openNamespace][data.item.modDetail] : options.options[data.item.modDetail],
        params: {
          id: data.id,
          folder: this.metadata.folder,
          base: JSON.stringify({
            id: data.id,
            ids: [data.id],
            ...this.metadata
          })
        }
      })
    },
    refreshTable () {
      if (this.$refs.table) this.$refs.table.refreshTable()
    }
  }
}
